import { GelAllDataRequestModel, GetAllDataGroupByRequest, VisitDetailsRequest } from './../models/reports-request.model';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
//Serives
import { HttpService } from 'src/app/modules/shared/services/http.service';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class VisitReportsService {

    reportUrl: string = environment.reportUrl;
    baseConfigURL: string = environment.configUrlV2;

    constructor(
        private httpService: HttpService,
        private http: HttpClient
    ){}

    getColumnSettings(moduleId: number, channelId: number, reportType: string){
        return this.httpService.getById(`${this.baseConfigURL}/ColumnSetting/Module/${moduleId}/Channel/${channelId}/reportType/${reportType}`);
    }

    getVisitByRepReports(requestModel: GelAllDataRequestModel){
        return this.httpService.create(`${this.reportUrl}FieldVisitReports/GetPagedListWithFilter`, requestModel);
    }

    getVisitResponseGroupList(requestModel: GetAllDataGroupByRequest){
        return this.httpService.create(`${this.reportUrl}SurveyQuestionResponse/GetGroupedPagedList`, requestModel);
    }

    getVisitResponseReports(requestModel: GelAllDataRequestModel){
        return this.httpService.create(`${this.reportUrl}SurveyQuestionResponse/GetPagedListWithFilter`, requestModel);
    }

    getVisitByRepGroupList(requestModel: GetAllDataGroupByRequest){
        return this.httpService.create(`${this.reportUrl}FieldVisitReports/GetGroupedPagedList`, requestModel);
    }

    getVisitByRepReportSummary(requestModel: GelAllDataRequestModel){
        return this.httpService.create(`${this.reportUrl}FieldVisitReports/GetVisitByReportSummary`, requestModel);
    }

    getVisitDetails(requestModel: VisitDetailsRequest){
        return this.httpService.create(`${this.reportUrl}FieldVisitReports/GetVisitReportDetails`, requestModel);
    }

    updateVisitColumnSettings(requestModel: any){
        return this.httpService.update(`${this.baseConfigURL}/ColumnSetting/VisitReport`, requestModel);
    }
}
